import React, { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import { NotificationContainer } from 'react-notifications';
import BaseRouter from '../routing/BaseRouter';
import { getCurrentUserData } from '../app/users/action-creators';
import CircularProgress from '../components/CircularProgress';
import { loadReferences } from '../app/reference/action-creators';
import { setScreenWidth } from '../app/settings/action-creators';

function Base(props) {
  const dispatch = useDispatch();
  const [userInited, setUserInited] = useState(false);

  useEffect(() => {
    dispatch(getCurrentUserData()).then(
      () => {
        setUserInited(true);
      },
      () => {
        setUserInited(true);
      },
    );
  }, [dispatch]);

  const onWindowWidthUpdate = () => {
    dispatch(setScreenWidth(window.innerWidth));
  };

  useEffect(() => {
    window.addEventListener('resize', onWindowWidthUpdate);
    return () => {
      window.removeEventListener('resize', onWindowWidthUpdate);
    };
  }, []);

  const { location } = props;
  return (
    <>
      {
        userInited
          ? <BaseRouter location={location} />
          : <CircularProgress />
      }
      <NotificationContainer />
    </>
  );
}

export default Base;
